Vendd.Scripts.load(function () {
    var $wrapper = $('.x-brand-widget');

    if ($wrapper.length < 1)
        return;


    //On click Brands Button
    $wrapper.on('click', '.js-widget-trigger', function (e) {
        e.preventDefault();

        if ($(this).hasClass('x-open')) {
            $('html').removeClass('hide-sticky-btns');
            $('.js-widget-trigger', $wrapper).removeClass('x-open');
            $('.js-widget-container', $wrapper).removeClass('x-expanded');
            if ($(window).width() < 960) {
                $('.header-overlay').removeClass('visible');
                $('html, body').removeClass('no-scroll');
            }
        } else {
            if ($(window).width() < 960) {
                $('.header-overlay').addClass('visible');
                $('html, body').addClass('no-scroll');
            }
            $('html').addClass('hide-sticky-btns');
            $('.js-widget-trigger', $wrapper).addClass('x-open');
            $('.js-widget-container', $wrapper).addClass('x-expanded'); 

            //init Plugin for Scrollbar
            initCustomScrollbar();
            //init Plugin for Search
            initSearch();

        }
    });

    $wrapper.on('click', '.js-close-brands', function (e) {
        e.preventDefault();

        $('html').removeClass('hide-sticky-btns');
        $('.js-widget-trigger', $wrapper).removeClass('x-open');
        $('.js-widget-container', $wrapper).removeClass('x-expanded');
        $('.header-overlay').removeClass('visible');
        $('html, body').removeClass('no-scroll');
    });

    //On click outside Brand Widget
    $(document).on('click', function (e) {

        if ($(window).width() < 960 || !$('.js-widget-trigger', $wrapper).hasClass('x-open'))
            return;

        if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
            $('.js-widget-trigger', $wrapper).removeClass('x-open');
            $('.js-widget-container', $wrapper).removeClass('x-expanded');
        }
    });

    function initCustomScrollbar() {

        var $scrollbar = $('.js-scrollbar', $wrapper);

        if (isTouch() || $scrollbar.hasClass('mCustomScrollbar'))
            return;

        $scrollbar.mCustomScrollbar({
            scrollbarPosition: "outside",
            scrollInertia: 400,
            timeout: 1000,
            theme: "dark-thin",
            mouseWheel: { preventDefault: true }
        });

    }

    function initSearch() {

        var options = {
            valueNames: ['brand']
        };

        var brandList = new List('brand-search', options);

        brandList.on('updated', function (list) {
            if (list.matchingItems.length > 0) {
                $('.no-result').hide();
            } else {
                $('.no-result').show();
            }
        });
    }

});

